import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.457 18.043a3.596 3.596 0 0 0 5.086 0l6.75-6.75a1 1 0 0 1 1.414 1.414l-6.75 6.75a5.596 5.596 0 1 1-7.914-7.914l7.5-7.5a4.182 4.182 0 1 1 5.914 5.914l-6.5 6.5a2.768 2.768 0 1 1-3.914-3.914l4.75-4.75a1 1 0 1 1 1.414 1.414l-4.75 4.75a.768.768 0 0 0 1.086 1.086l6.5-6.5a2.182 2.182 0 0 0-3.086-3.086l-7.5 7.5a3.596 3.596 0 0 0 0 5.086",
      clipRule: "evenodd"
    }
  )
);
var SvgClipOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ClipOutlined_default = SvgClipOutlined;

export { ClipOutlined_default as default };
